import { useTranslation } from 'react-i18next';
// ... existing code ...

export default function MathAlgorithm() {
  const { t } = useTranslation();
  // ... existing code ...

  return (
    <section id="math-algorithm" className="py-16 md:py-24 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #0c0814 0%, #100b1e 100%)' }}>
      <div className="absolute inset-0 grid-bg pointer-events-none opacity-50"></div>
      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-10 md:mb-16">
          <div className="badge-purple mx-auto mb-6" style={{ display: 'inline-flex' }}>
            <i className="ri-function-line text-xs"></i>
            {t('mathAlgo.badge')}
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-6 font-display" style={{ letterSpacing: '-0.03em', lineHeight: '1.08' }}>
            {t('mathAlgo.title1')}
            <span className="text-gradient-aurora"> {t('mathAlgo.title2')}</span>
          </h2>
          <div className="max-w-3xl mx-auto premium-card border border-purple-400/12 rounded-2xl px-8 py-6 text-left">
            <div className="flex gap-3">
              <i className="ri-double-quotes-l text-3xl text-purple-400/60 shrink-0 mt-1"></i>
              <p className="text-white/50 text-lg leading-relaxed">
                {t('mathAlgo.quote')}
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          {/* Chapter 0 - always open */}
          <div className="rounded-2xl border border-purple-400/20 bg-purple-400/[0.03] overflow-hidden">
            <div className="px-4 md:px-8 pb-6 md:pb-8 pt-6 md:pt-8">
              <div className="flex items-center gap-4 mb-5">
                <div className="w-12 md:w-14 h-12 md:h-14 rounded-2xl flex items-center justify-center shrink-0" style={{ background: 'linear-gradient(135deg,#9333ea,#7c3aed)' }}>
                  <i className="ri-bar-chart-2-line text-xl md:text-2xl text-white"></i>
                </div>
                <div>
                  <span className="text-purple-400 text-xs md:text-sm font-mono font-bold">01</span>
                  <h3 className="text-sm md:text-lg font-bold text-white">{t('mathAlgo.ch0_title')}</h3>
                </div>
              </div>
              <div className="border-t border-purple-500/10 pt-5 md:pt-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <div className="border border-amber-500/30 rounded-2xl p-6" style={{ background: 'rgba(245,158,11,0.08)' }}>
                      <div className="text-amber-400 text-sm font-semibold mb-2">{t('mathAlgo.coreData')}</div>
                      <div className="flex items-baseline gap-3 mb-2">
                        <span className="text-5xl font-black text-white">$0.60</span>
                        <span className="text-amber-400 text-sm">Median Deviation</span>
                      </div>
                    </div>
                    <div className="rounded-2xl p-6 border border-purple-500/20" style={{ background: 'rgba(168,85,247,0.05)' }}>
                      <div className="text-white/40 text-xs mb-4">{t('mathAlgo.pipeline4')}</div>
                      <div className="space-y-2">
                        {[t('mathAlgo.layer0'), t('mathAlgo.layer1'), t('mathAlgo.layer2'), t('mathAlgo.layer3')].map((s, i) => (
                          <div key={i} className="flex items-center gap-3">
                            <div className="w-7 h-7 rounded-full bg-purple-600 flex items-center justify-center text-white text-xs font-bold shrink-0">{i + 1}</div>
                            <div className="flex-1 h-8 rounded-lg flex items-center px-3 text-white/80 text-sm font-medium border border-purple-500/20" style={{ background: 'rgba(168,85,247,0.08)' }}>{s}</div>
                          </div>
                        ))}
                      </div>
                      <div className="mt-4 rounded-xl px-4 py-2 border border-emerald-500/30 text-center" style={{ background: 'rgba(16,185,129,0.08)' }}>
                        <span className="text-emerald-300 text-sm font-bold">{t('mathAlgo.annualReturn')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="rounded-2xl p-4 md:p-6 border border-purple-500/20" style={{ background: 'rgba(168,85,247,0.04)' }}>
                    <h4 className="text-center text-white font-bold text-sm md:text-base mb-4">{t('mathAlgo.pipeline_title')}</h4>
                    <div className="space-y-3">
                      {[
                        { label: t('mathAlgo.layer0'), nodes: ['WebSocket', 'Polygon Node', 'Binance/CEX', '86M Records'], cls: 'bg-white/[0.06] border-white/15' },
                        { label: t('mathAlgo.layer1'), nodes: ['Claude 4.6 Sonnet', 'Integer Programming'], cls: 'bg-violet-900/40 border-violet-400/30' },
                        { label: t('mathAlgo.layer2'), nodes: ['LCMM Linear', 'Frank-Wolfe + Gurobi', 'Pre-execution Verify'], cls: 'bg-emerald-900/40 border-emerald-500/30' },
                        { label: t('mathAlgo.layer3'), nodes: ['CLOB Execution', 'Modified Kelly'], cls: 'bg-rose-900/40 border-rose-500/30' },
                      ].map((layer, li, arr) => (
                        <div key={li}>
                          <div className="text-purple-400 text-xs mb-2 ml-1 font-medium">{layer.label}</div>
                          <div className={`grid gap-2 ${layer.nodes.length === 4 ? 'grid-cols-2 md:grid-cols-4' : layer.nodes.length === 3 ? 'grid-cols-2 md:grid-cols-3' : 'grid-cols-2'}`}>
                            {layer.nodes.map((n, ni) => (
                              <div key={ni} className={`${layer.cls} border rounded-xl px-3 py-2.5 text-center`}>
                                <div className="text-white font-bold text-xs">{n}</div>
                              </div>
                            ))}
                          </div>
                          {li < arr.length - 1 && <div className="flex justify-center my-1.5"><i className="ri-arrow-down-line text-purple-400 text-lg"></i></div>}
                        </div>
                      ))}
                      <div className="flex justify-center mt-3">
                        <div className="bg-emerald-500/20 border-2 border-emerald-400/40 rounded-xl px-6 py-2.5 text-center">
                          <div className="text-emerald-300 font-bold text-sm">{t('mathAlgo.annualProfit')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Chapter 1 & 2 collapsed */}
          {[
            { num: '02', titleKey: 'mathAlgo.ch1_title', tagKey: 'mathAlgo.ch1_tag', icon: 'ri-git-merge-line' },
            { num: '03', titleKey: 'mathAlgo.ch2_title', tagKey: 'mathAlgo.ch2_tag', icon: 'ri-focus-3-line' },
          ].map((ch) => (
            <div key={ch.num} className="rounded-2xl border border-white/5 bg-white/[0.015] hover:border-purple-400/12 overflow-hidden">
              <div className="flex items-center gap-3 md:gap-5 px-4 md:px-8 py-4 md:py-6">
                <div className="w-12 md:w-14 h-12 md:h-14 rounded-2xl flex items-center justify-center shrink-0 bg-white/[0.04] border border-white/8">
                  <i className={`${ch.icon} text-xl md:text-2xl text-purple-400`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-purple-400 text-xs font-mono font-bold">{ch.num}</span>
                  <h3 className="text-sm md:text-lg font-bold text-white leading-snug">{t(ch.titleKey)}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
